import axiosInstance from 'ns_libs/nsAxios';
import API_ENDPOINTS from 'services/urls';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';

export interface IDeleteExtractedProFormaVariables {
    organizationId: string;
    dealId: number;
    extractedProFormaId: number;
}

const useDeleteExtractedProForma = (
    options: Omit<UseMutationOptions<void, AxiosError, IDeleteExtractedProFormaVariables>, 'mutationFn'> = {},
) => useMutation({
    mutationFn: async (variables: IDeleteExtractedProFormaVariables) => {
        const { organizationId, dealId, extractedProFormaId } = variables;
        const res = await axiosInstance.delete<void>(
            API_ENDPOINTS.EXTRACTED_PRO_FORMA(organizationId, dealId, extractedProFormaId),
        );
        return res.data;
    },
    ...options,
});

export default useDeleteExtractedProForma;
